var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityShieldIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.24151 0.126729C6.73307 -0.0422431 7.26693 -0.0422431 7.75849 0.126729L12.4252 1.7309C13.3674 2.05479 14 2.94119 14 3.9375V7.62025C14 9.80332 13.1064 11.3765 11.8125 12.6015C10.5895 13.7593 8.98738 14.6233 7.49148 15.4299L7.36929 15.4958C7.13883 15.6202 6.86117 15.6202 6.63071 15.4958L6.50852 15.4299C5.01265 14.6233 3.4105 13.7593 2.1875 12.6015C0.893597 11.3765 0 9.80332 0 7.62025V3.93751C0 2.94119 0.632613 2.05479 1.57481 1.7309L6.24151 0.126729ZM9.49441 6.48812C9.79813 6.1844 9.79813 5.69192 9.49441 5.38818C9.19069 5.08444 8.6982 5.08444 8.39448 5.38818L6.22222 7.56044L5.60552 6.94374C5.30178 6.64002 4.80933 6.64002 4.50558 6.94374C4.20184 7.24746 4.20184 7.73995 4.50558 8.04367L5.67226 9.21034C5.81809 9.35618 6.01596 9.43815 6.22222 9.43815C6.42849 9.43815 6.62636 9.35618 6.77219 9.21034L9.49441 6.48812Z",
    fill: "#F65E18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityShieldIcon);
export default __webpack_public_path__ + "static/media/security-shield-icon.e70ce494bac99aae0f16cab4ff2bf221.svg";
export { ForwardRef as ReactComponent };